import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    createaccount,
    listaccounts,
    viewaccount,
    listactiveaccounttypes,
    listaccountgroupsbytype
} from "../../../../services/admin";
import { toast } from "react-toastify";
import Select from "react-select";

export default function AddAccount() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [parentAccounts, setParentAccounts] = useState([]);
    const [accountTypes, setAccountTypes] = useState([]);
    const [accountGroups, setAccountGroups] = useState([]);
    const [selectedTypeId, setSelectedTypeId] = useState(null);
    const [formData, setFormData] = useState({
        id: 0,
        account_code: "",
        account_name: "",
        account_type: "",
        account_group: "",
        parent_account_id: null,
        description: "",
        opening_balance: 0,
        opening_balance_type: "Debit",
        opening_balance_date: "",
        is_active: true,
    });

    useEffect(() => {
        // Fetch account types
        listactiveaccounttypes().then((res) => {
            if (res.status === true) {
                setAccountTypes(res.data);
            }
        });

        // Fetch parent accounts
        const branchId = localStorage.getItem("branch");
        listaccounts(branchId).then((res) => {
            if (res.status === true) {
                const options = res.data.details.map((acc) => ({
                    value: acc.id,
                    label: `${acc.account_code} - ${acc.account_name}`,
                }));
                setParentAccounts(options);
            }
        });

        // If editing, fetch account data
        if (id) {
            viewaccount(id).then((res) => {
                if (res.status === true) {
                    const data = res.data.details;
                    setFormData({
                        id: data.id,
                        account_code: data.account_code,
                        account_name: data.account_name,
                        account_type: data.account_type,
                        account_group: data.account_group || "",
                        parent_account_id: data.parent_account_id,
                        description: data.description || "",
                        opening_balance: data.opening_balance,
                        opening_balance_type: data.opening_balance_type,
                        opening_balance_date: data.opening_balance_date || "",
                        is_active: data.is_active,
                    });
                    // Find the type ID for the selected type to load groups
                    listactiveaccounttypes().then((typesRes) => {
                        if (typesRes.status === true) {
                            const type = typesRes.data.find(t => t.type_name === data.account_type);
                            if (type) {
                                setSelectedTypeId(type.id);
                                fetchAccountGroups(type.id);
                            }
                        }
                    });
                }
            });
        }
    }, [id]);

    // Fetch account groups when type is selected
    const fetchAccountGroups = (typeId) => {
        if (typeId) {
            listaccountgroupsbytype(typeId).then((res) => {
                if (res.status === true) {
                    setAccountGroups(res.data);
                }
            });
        } else {
            setAccountGroups([]);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleAccountTypeChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            account_type: selectedOption.value,
            account_group: "", // Reset group when type changes
        }));
        // Fetch groups for selected type
        setSelectedTypeId(selectedOption.id);
        fetchAccountGroups(selectedOption.id);
    };

    const handleParentAccountChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            parent_account_id: selectedOption ? selectedOption.value : null,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.account_code) {
            toast.error("Please enter account code");
            return;
        }
        if (!formData.account_name) {
            toast.error("Please enter account name");
            return;
        }
        if (!formData.account_type) {
            toast.error("Please select account type");
            return;
        }

        // Add branch_id from localStorage
        const submitData = {
            ...formData,
            branch_id: localStorage.getItem("branch")
        };

        createaccount(submitData).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
                navigate("/accounts/allaccounts");
            }
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    {id ? "Edit Account" : "Add Account"}
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        {id ? "Edit Account" : "Add Account"}
                    </li>
                </ol>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-6">
                                    <h4 className="card-title">
                                        {id ? "Edit Account" : "Add Account"}
                                    </h4>
                                </div>
                                <div className="col-6 text-end">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => navigate("/accounts/allaccounts")}
                                    >
                                        <i className="fa fa-arrow-left"></i> Back
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Account Code <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="account_code"
                                            value={formData.account_code}
                                            onChange={handleInputChange}
                                            disabled={id ? true : false}
                                        />
                                    </div>

                                    <div className="col-md-8 mb-3">
                                        <label className="form-label">
                                            Account Name <span className="text-danger">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="account_name"
                                            value={formData.account_name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">
                                            Account Type <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            options={accountTypes.map((type) => ({
                                                value: type.type_name,
                                                label: type.type_name,
                                                id: type.id
                                            }))}
                                            value={accountTypes
                                                .map((type) => ({
                                                    value: type.type_name,
                                                    label: type.type_name,
                                                    id: type.id
                                                }))
                                                .find((opt) => opt.value === formData.account_type)}
                                            onChange={handleAccountTypeChange}
                                            placeholder="Select Type"
                                        />
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Account Group</label>
                                        <select
                                            className="form-control"
                                            name="account_group"
                                            value={formData.account_group}
                                            onChange={handleInputChange}
                                            disabled={!formData.account_type || accountGroups.length === 0}
                                        >
                                            <option value="">Select Group</option>
                                            {accountGroups.map((group) => (
                                                <option key={group.id} value={group.group_name}>
                                                    {group.group_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        <label className="form-label">Parent Account</label>
                                        <Select
                                            options={parentAccounts}
                                            value={parentAccounts.find(
                                                (opt) => opt.value === formData.parent_account_id
                                            )}
                                            onChange={handleParentAccountChange}
                                            placeholder="Select Parent Account"
                                            isClearable
                                        />
                                    </div>
                                </div>

                                {!id && (
                                    <>
                                        <hr />
                                        <h5 className="mb-3">Opening Balance</h5>
                                        <div className="row">
                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Opening Balance</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    name="opening_balance"
                                                    value={formData.opening_balance}
                                                    onChange={handleInputChange}
                                                    step="0.01"
                                                    min="0"
                                                />
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">Balance Type</label>
                                                <select
                                                    className="form-control"
                                                    name="opening_balance_type"
                                                    value={formData.opening_balance_type}
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="Debit">Debit</option>
                                                    <option value="Credit">Credit</option>
                                                </select>
                                            </div>

                                            <div className="col-md-4 mb-3">
                                                <label className="form-label">As On Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="opening_balance_date"
                                                    value={formData.opening_balance_date}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleInputChange}
                                            rows="3"
                                        ></textarea>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12 mb-3">
                                        <div className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                name="is_active"
                                                checked={formData.is_active}
                                                onChange={handleInputChange}
                                            />
                                            <label className="form-check-label">Active</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12 text-end">
                                        <button
                                            type="button"
                                            className="btn btn-secondary me-2"
                                            onClick={() => navigate("/accounts/allaccounts")}
                                        >
                                            Cancel
                                        </button>
                                        <button type="submit" className="btn btn-primary">
                                            <i className="fa fa-save"></i>{" "}
                                            {id ? "Update Account" : "Create Account"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
